import YYTable from './table'
export default YYTable